export default __webpack_public_path__ + "static/media/chart-icon2.c31b7f92.svg";